module.exports = __webpack_public_path__ + "img/bn.7fbfa4ff.svg";